export default __webpack_public_path__ + "static/media/pirate.4ba50763.glb";